<template>
  <div class="Choice" :class="{'Choice--checked': this.checked }">
    <component :is="type" :label="label">
      <div class="Choice-Card" :class="classes">
        <!-- <div v-if="img" class="Choice-Card-img" :style="`background-image: url('${img}')`"></div> -->
        <div v-if="img" class="Choice-Card-img">
          <img :src="img" alt="">
        </div>
        <h3 class="Choice-Card-title">{{ title }}</h3>
        <slot></slot>
      </div>
    </component>
  </div>
</template>

<script>
export default {
  props: ['label', 'title', 'img'],
  data () {
    return {
      type: this.$parent.$parent.type,
      children: this.$children
    }
  },
  computed: {
    classes () {
      return [
        { 'is-checked': this.checked },
        { 'is-dirty': this.dirty && !this.checked && this.type === 'radio' }
      ]
    },
    dirty () {
      return this.$parent.$parent.dirty
    },
    checked () {
      const { children } = this
      if (children.length) {
        return children[0].currentValue
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.Choice {
  .ivu-radio, .ivu-checkbox { display: none; }
}
</style>

<style lang="scss" scoped>
@import '../scss/vars';

.Choice {
  display: inline-block;
  vertical-align: top;
}
.Choice-Card {
  display: inline-block;
  border: 1px solid #EBF3F8;
  border-radius: 8px;
  height: 255px;
  width: 200px;
  padding: 50px 25px;
  white-space: initial;
  font-family: $font-1;
  color: $color-1;
  font-size: 12px;
  text-align: center;
  box-shadow: none;
  transition: border linear .15s, box-shadow linear .15s;

  &.is-checked {
    border-color: $color-1;
    box-shadow: 0 6px 8px rgba(#A2C0E2, .2);
  }

  &.is-dirty {
    opacity: .5;
    background-color: #F8FBFC;
  }

  &:hover {
    border-color: lighten($color-1, 10%);
  }

  @media (max-width: 768px) {
    width: 115px;
    padding: 25px 10px;
  }
}

.Choice-Card-img {
  width: 55px;
  height: 55px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin: 0 auto 25px auto;

  @media (max-width: 768px) {
    width:  40px;
    height: 40px;
    margin: 0 auto 10px auto;
    font-size: 13px;
  }

  img {
    max-width: 100%;

    @media (max-width: 768px) {
      max-height: 100%;
    }
  }
}

.Choice-Card-title {
  color: #ff4e4e;
  line-height: 1.3;
  margin-bottom: 10px;
  white-space: normal;
  word-break: break-word;
}

.Choices--small .Choice-Card {
  min-height: 165px;
  height: auto;
  width: 130px;
  margin: 0 10px 20px 0;
  padding: 30px 15px;

  @media (max-width: 768px) {
    width: 120px;
    margin: 0 5px 15px 5px;
  }
}
</style>
